import {
  AllCaps,
  FeaturedItemGrid,
  H2,
  PlaceholderBlock,
  Stack,
  Text,
} from "atoms";
import styled from "@emotion/styled";
import { ReviewableCard, useArtist } from "features/reviewable";
import type { ShopDataResp } from "../types";

type ShopComingSoonProps = {
  artists: ShopDataResp["comingSoon"];
};

function ShopComingSoon({ artists }: ShopComingSoonProps) {
  return (
    <Stack gap="sm">
      <Stack>
        <H2 size="xxl" textAlign="center" style={{ paddingTop: 40 }}>
          More Storefronts Coming Soon
        </H2>
        <Text
          textAlign="center"
          style={{ maxWidth: 700, marginInline: "auto" }}
        >
          Whether you are a photographer, illustrator, or calligrapher, draw
          inspiration from how different creators are monetizing their craft and
          know-how on <AllCaps>Hug</AllCaps>.
        </Text>
      </Stack>
      <FeaturedItemGrid showAll>
        {artists.map(([artistId, date]) => (
          <ComingSoonCard key={artistId} artistId={artistId} date={date} />
        ))}
      </FeaturedItemGrid>
    </Stack>
  );
}

type ComingSoonCardProps = {
  artistId: ShopDataResp["comingSoon"][number][0];
  date: ShopDataResp["comingSoon"][number][1];
};

function ComingSoonCard({ artistId, date }: ComingSoonCardProps) {
  const { data } = useArtist(artistId);

  if (data) {
    return (
      <ReviewableCard
        {...data}
        footer={<LaunchDate>Launches {date}</LaunchDate>}
        acceptsCommissions={false}
      />
    );
  }

  return <PlaceholderBlock />;
}
const LaunchDate = styled.div(({ theme }) => ({
  ...theme.fonts.display,
  fontSize: 14,
  paddingBlock: 6,
  paddingInline: 8,
  lineHeight: 1,
  color: theme.colors.fg90,
  backgroundColor: theme.colors.fg10,
  borderRadius: theme.borderRadius.sm,
  textAlign: "center",
}));

export { ShopComingSoon };
